<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<div class="sheet-top-level">
	<title-header
		class="ticket-edit-title"
		[title]="ticketTitle$ | async"
		(closeButtonClicked)="handleCloseButton()"
		iconName="attach_file"
		[showIcon]="true"
	></title-header>

	<attached-images
		*ngIf="ticketEditService.fileAttachEnabled$ | async"
		class="attachments"
		[ticketContext]="ticketContext"
		[ticketId]="ticketContext.ticketId$ | async"
	></attached-images>
	<!-- TODO: To be commented in when docked-ticket is completed. Might need to shuffle around some of the desktop side stuff. -->
	<!-- <docked-ticket
		[ticket$]="ticket$"
		[roles$]="roles$"
		[locations$]="locations$"
		[projectMembers$]="projectMembers$"
		[priorityList$]="priorityList$"
		[ticketContext]="ticketContext"
		[combinedEdit$]="ticketEditService.combinedEdit$"
		[customFieldsApi]="planState.customFieldsApi"
		[saveCustomFieldsRequested$]=""
		[cancelCustomFieldsRequested$]=""
		[planAccessCheck]="planState.planAccessCheck"
	></docked-ticket> -->
</div>
